var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"header-container"},[_c('img',{attrs:{"src":"/static/image/ic_area_header.png"}}),_vm._v(" "),_c('span',{staticClass:"title"},[_vm._v(_vm._s(_vm.title))]),_vm._v(" "),(_vm.rightText.length > 0 )?_c('a',{staticClass:"right",on:{"click":_vm.rightClick}},[_vm._v(_vm._s(_vm.rightText))]):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }